<template>
  <div id="data-list-groups" class="data-list-container">
    <vs-table ref="table" responsive pagination :max-items="itemsPerPage" search :data="originList">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
            <div
              class="
                p-4
                border border-solid
                d-theme-border-grey-light
                rounded-full
                d-theme-dark-bg
                cursor-pointer
                flex
                items-center
                justify-between
                font-medium
              "
            >
              <span class="mr-2">{{ minItemsPerPage }} - {{ currentItemsPerPage }} of {{ queriedItems }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
              <vs-dropdown-item @click="itemsPerPage = 4">
                <span>4</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="itemsPerPage = 50">
                <span>50</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">{{$t(`ANALITICS.name`)}}</vs-th>
        <vs-th sort-key="description">{{$t(`ANALITICS.url`)}}</vs-th>
        <vs-th sort-key="companyName">{{$t(`ANALITICS.company`)}}</vs-th>
        <vs-th sort-key="status">{{$t(`ANALITICS.status`)}}</vs-th>
        <vs-th>{{$t(`ANALITICS.actions`)}}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.name }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.uri }}</p>
            </vs-td>
            <vs-td>
              <p class="product-category">{{ tr.companyName }}</p>
            </vs-td>

            <vs-td>
              {{ tr.status | TranslateStatus }}
              <!-- <vs-progress :percent="100" :color="tr.status | getPopularityColor" class="shadow-md" /> -->
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                class="ml-2"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-success stroke-current"
                @click.stop="editStatistic(tr)"
              />

              <feather-icon
                class="ml-2"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                @click.stop="deleteData(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import * as Statistics from "./Statistics";
import { notify } from "@/helpers/$vs.js";

export default {
  data() {
    return {
      activeForm: {},
      activePrompt: false,
      selectedFormVersion: 1,

      activePopup: false,
      listGroups: [],

      recordId: null,
      originList: [],
      itemsPerPage: 7,
      isMounted: false
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        // return this.$refs.table.currentx;
        return true;
      }
      return 0;
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.originList.length;
    },
    minItemsPerPage() {
      return this.currentPage * this.itemsPerPage - (this.itemsPerPage - 1);
    },
    currentItemsPerPage() {
      return this.originList.length - this.currentPage * this.itemsPerPage > 0
        ? this.currentPage * this.itemsPerPage
        : this.originList.length;
    }
  },
  filters: {
    TranslateStatus(status) {
      const translate = status === "Active" ? "Activo" : "Inactivo";
      return translate;
    },
    getPopularityColor(status) {
      switch (status) {
        case "Active":
          return "primary";
          break;
        case "Inactive":
          return "warning";
          break;
        case "Blocked":
          return "danger";
          break;
        case "Banned":
          return "danger";
          break;
        case "Deleted":
          return "danger";
          break;
        default:
          return "warning";
          break;
      }
    }
  },
  methods: {
    /**
     * Consume el servicio para obtener la lista de estadísticas para visualizarlas en la vista, y mostrar un mensaje de error si se prensento un fallo en la ejecución.
     */
    async getAllStadistic() {
      this.$vs.loading({ type: "sound" });

      try {
        const result = await Statistics.getAllStadistic();
        this.originList = result;
      } catch (error) {
        const message = error.error ? error.error : `(${error.message})`;
        let text = "";

        if (message === "Groups are empty") text = this.$t(`ANALITICS.emptyStatistic`);

        notify("Grupos", text, "warning");
      } finally {
        this.$vs.loading.close();
      }
    },
    /**
     * Muestra un dialogo de conformación antes de eliminar una de las estadisticas.
     * @param {Objeto} data - Objeto con la información de la estadística, la cual contiene el ID ó KEY para su posterior eliminación.
     */
    deleteData(data) {
      this.recordId = data.key;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `${this.$t(`ANALITICS.deleteStatistic`)} ${data.name}`,
        text: this.$t(`ANALITICS.alertMessage`),
        acceptText: this.$t(`ANALITICS.accept`),
        cancelText: this.$t(`ANALITICS.cancel`),
        accept: () => this.deleteOriginItem(this.recordId)
      });
    },

    /**
     * Consume el servicio de eliminar una estadística
     * @param {string} idStatistic - ID de la estadística a eliminar.
     */
    async deleteOriginItem(idStatistic) {
      this.$vs.loading({ type: "sound" });
      try {
        await Statistics.deleteStadistic(idStatistic);
        await this.getAllStadistic();
      } catch (error) {
        console.log("deleteOriginItem Error:", error);

        if (error.status === 718 && error.message === "You are not authorized to access the requested resource.") {
          return this.$vs.notify({
            title: this.$t(`ANALITICS.deleteStatistics`),
            text: this.$t(`ANALITICS.NotAutorization`),
            color: "warning",
            icon: "error",
            time: 6000
          });
        }

        this.$vs.notify({
          title: this.$t(`ANALITICS.deleteStatistics`),
          text: this.$t(`ANALITICS.erroToDelete`),
          color: "warning",
          icon: "error",
          time: 6000
        });
      } finally {
        this.recordId = null;
        this.$vs.loading.close();
      }
    },
    editStatistic(tr) {
      this.$emit("key", tr.key)
    }
  },
  mounted() {
    this.isMounted = true;
    this.getAllStadistic();
  }
};
</script>

<style lang="scss">
#data-list-groups {
  @import "@/assets/css/_themeTable.scss";
}
</style>
